/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Type of the person relation
 */
export enum DocumentPersonType {
    LINK = 'link',
    SELLER = 'seller',
    BUYER = 'buyer',
    ISSUER = 'issuer',
}
